import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCopyPost = {
    path: "/:objectType/multilingual/copy",
    namespace: "wp/v2",
    method: RouteHttpVerb.POST
};
export { locationRestCopyPost };
